import { render } from "./BarHorizontalChart.vue?vue&type=template&id=5ff5c1a0"
import script from "./BarHorizontalChart.vue?vue&type=script&lang=js"
export * from "./BarHorizontalChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__